import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useAppContext } from "../app/AppContext";
import styles from "./LegalPage.module.css";

/**
 * A real not-found page for URLs no tree knows (signed out and signed in). Member
 * paths opened signed out never land here: the public tree lists them explicitly and
 * renders the sign-in screen in place so the deep link survives the exchange.
 */
export function NotFoundPage() {
  const { viewer } = useAppContext();
  return (
    <section className={styles.page} role="alert" data-not-found>
      <header className={styles.header}>
        <h1 className={styles.title}>
          <FormattedMessage id="notFound.title" />
        </h1>
        <p className={styles.intro}>
          <FormattedMessage id="notFound.body" />
        </p>
      </header>
      <p className={styles.paragraph}>
        <Link to={viewer ? "/templates" : "/"}>
          <FormattedMessage id={viewer ? "notFound.templates" : "notFound.home"} />
        </Link>
      </p>
    </section>
  );
}
